export const verificationStatusOption = [
  { label: "All", value: null },
  { label: "ADDRESS", value: "address" },
  { label: "BVN", value: "bvn" },
  { label: "CAC", value: "cac" },
  { label: "PHONE", value: "phone" },
  { label: "NIN", value: "nin" },
];

export const kycStatusOption = [
  { label: "All", value: null },
  { label: "ADDRESS_KYC", value: "ADDRESS_KYC" },
  { label: "BVN_KYC", value: "BVN_KYC" },
  { label: "CAC_KYC", value: "CAC_KYC" },
  { label: "BEGINNER", value: "BEGINNER" },
  { label: "NIN_KYC", value: "NIN_KYC" },
];
